import React, { useCallback } from 'react';
import { EmptySvg } from '@yme/assets/icons';
import { noop } from '@yme/utils/common';
import { SVGIconStyled } from './SvgIconStyled';
import { ICON_SIZE } from './constants';
import { getCorrectSize } from './helpers';
import { SVG } from './svgInline';
/**
 * SVG Component
 * @param type - Type of Icons from Folder 'Assets'; Default value: 'EmptySvg';
 * @param fill - Default value: 'none';
 * @param size - Default value = 'ICON_SIZE.s'; (import { ICON_SIZE } from '@yme/atoms/svg-icon')
 * @param className - BackPort option, for make styles with 'ClassName'; Default value: 'wrap-svg',
 * @param onClick - custom event
 * @param viewBox -
 * @param dataIconType - optional property;
 *
 * @returns JSX.Element
 */
export function SVGIcon(props) {
    const { type = EmptySvg, fill = 'none', pathFill, rectFill, stroke, size = ICON_SIZE.s, className = 'wrap-svg', onClick, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    viewBox, // TODO: Need adjust this property
    dataIconType, children, order, iconRotate, title, isHoverEffect, tabIndex, isActive, keyDownHandler = noop, uniquifyIDs, ...rest } = props;
    const { correctSize, correctSizes } = getCorrectSize(size);
    const svgSize = correctSizes ? undefined : correctSize;
    const svgKey = `${type}-${fill}-${svgSize}-${dataIconType}`;
    const onClickHandler = useCallback((e) => {
        onClick && onClick(e);
    }, [onClick]);
    return (React.createElement(SVGIconStyled, { size: correctSize, sizes: correctSizes, onClick: onClickHandler, className: className, iconRotate: iconRotate, order: order, title: title, tabIndex: tabIndex, onKeyDown: keyDownHandler, pathFill: pathFill, rectFill: rectFill, stroke: stroke, role: onClick ? 'button' : undefined, isButton: Boolean(onClick), isHoverEffect: isHoverEffect, isActive: isActive }, type ? (React.createElement(React.Fragment, null,
        React.createElement(SVG, { key: svgKey, src: `${type}`, height: svgSize, className: "icon-svg", width: svgSize, cacheRequests: true, uniquifyIDs: uniquifyIDs, ...rest }),
        children && React.createElement("span", null, children))) : (React.createElement(SVGIconStyled, { size: correctSize, sizes: correctSizes }))));
}
